import React from "react";
import "./TrialPeriodExpiredModal.scss";

import TrialPeriodExpired from "static/icons/trial-period-expired.svg"
import UniversalButton from "../../uiComponents/UniversalButton";

const TrialPeriodExpiredModal = () => {

  const onActionClick = () => {
    window.open('https://bim-search.com/pricing-bimsearch');
  }

  return (
    <div className="trial-period-expired">
      <img
        className="trial-period-expired__img"
        src={TrialPeriodExpired}
      />

      <div className="trial-period-expired__content">
        <p className="trial-period-expired__content-title">
          Trial period has expired!
        </p>

        <p className="trial-period-expired__content-text">
          Your free trial period has expired.<br/>
          BIMSearch has been locked,<br/>
          but don’t worry your work has been saved.<br/>
          Subscribe now to continue using BIMSearch.
        </p>

        <div className="trial-period-expired__button-container">
          <UniversalButton
            label="Subscribe now"
            size="lg"
            labelColor="white"
            labelHoverColor="white"
            backgroundColor="orange"
            backgroundHoverColor="orange-light"
            onClick={onActionClick}
          />
        </div>
      </div>
    </div>
  );
};

export default TrialPeriodExpiredModal;
